module.exports = __webpack_public_path__ + "static/media/accordian-up.8aacb5d8.svg";